import { throttle } from "../utils/performance";
import { mediaMin } from "../utils/breakpoints";

export default function(el) {
    let animation = null;

    const getSrc = () => {
        const currentSrc = el.dataset.currentSrc;

        const src = !mediaMin("md") && el.dataset.srcMobile ? el.dataset.srcMobile : el.dataset.src;

        if (!src || src === currentSrc) return;

        el.dataset.currentSrc = src;

        return src;
    };

    const loadAnimation = () => {
        const src = getSrc();

        if (!src) return;

        if (animation) animation.destroy();

        animation = lottie.loadAnimation({
            container: el,
            path: src,
            renderer: "canvas",
            loop: true,
            autoplay: true,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
        });
    };

    const handleResizeEvent = throttle(loadAnimation, 200);

    loadAnimation();
    window.addEventListener("resize", handleResizeEvent);
}
